import jquery from 'jquery';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/modal';

window.$ = window.jQuery = window.jquery = jquery;

require('sticky-kit/dist/sticky-kit');
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        'accept': 'image/webp'
    }
});
$.postJSON = function(url, data, callback) {
    return jQuery.ajax({
        'type': 'POST',
        'url': url,
        'headers': {
        'Accept': 'application/json'
        },
        'contentType': 'application/json',
        'data': JSON.stringify(data),
        'dataType': 'json',
        'success': callback
    });
};


window.showLoader = function() {
    jQuery('#global-loader').show();
};
window.hideLoader = function() {
    jQuery('#global-loader').hide();
};
